import { DAY_ORDER, DayKey, OperatingHours } from './types';

export interface HoursValidation {
  ok: boolean;
  errors: Partial<Record<DayKey, string>>;
}

// An open day needs both times, with close after open. Closed days never error.
export const validateHours = (hours: OperatingHours | null): HoursValidation => {
  const errors: Partial<Record<DayKey, string>> = {};
  if (!hours) return { ok: true, errors };

  for (const day of DAY_ORDER) {
    const { closed, open, close } = hours[day];
    if (closed) continue;
    if (!open || !close) {
      errors[day] = 'Set an open and close time, or mark the day closed.';
    } else if (open >= close) {
      errors[day] = 'Closing time must be after opening time.';
    }
  }

  return { ok: Object.keys(errors).length === 0, errors };
};
